/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { Fade } from 'react-awesome-reveal';
import { Col, Row, Tooltip } from 'react-bootstrap';
import { Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import {} from 'store/home/home-my-view-actions';
import ConfigurableTable from 'components/shared/table/ConfigurableTable';

import {
  COMPONENT_MAPPING,
  PAGINATION,
  QUERY_KEY,
  SITE_AFFILIATIONS_COLUMNS,
  SORT_BY,
  TABLE_NAME_SITE_AFFILIATION,
} from 'constants/constants';

import {
  exportData,
  getAffiliationsDataSite,
} from 'store/customer/customer-view-actions';
import { resetAffiliationFilters } from 'store/customer/customerViewSlice';
import AffiliationsFilters from './AffiliationsFilter';
import { getRestrictedColumn } from 'utils/utils';
import OverlayTrigger from 'components/shared/tooltip/Tooltip';
import OverlayIcon from 'components/shared/overlay-icon/OverlayIcon';
import { useQuery } from '@tanstack/react-query';

const SiteAffiliations = ({
  columns,
  filterExp,
  enableTitle,
  corpParent,
  tableType,
}) => {
  const dispatch = useDispatch();
  const [filterExpression, setFilterExpression] = useState(filterExp);
  const isExporting = useSelector(
    (state) => state?.CustomerView?.exportAffiliation
  );
  const hcpFlag = useSelector((state) => state?.CustomerView.hcpFlag);

  const selectedCustomer = useSelector(
    (state) => state?.CustomerView?.selectedCustomer
  );
  const affiliationExpression = useSelector(
    (state) => state?.CustomerView?.affiliationsExpression
  );
  const columnRestriction = useSelector(
    (state) => state?.CustomerView?.columnsRestiction
  );
  const activeSectionTab = useSelector(
    (state) => state?.CustomerView?.activeSectionTab
  );

  const account = {
    id: selectedCustomer?.value,
    name: selectedCustomer?.label,
  };

  const initailState = {
    values: [],
    offset: 0,
    totalSize: 0,
  };

  const [affiliationData, setAffiliationData] = useState(initailState);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(PAGINATION.defaultPageSize);
  const [sortBy, setSortBy] = useState({
    column: 'hcpName',
    order: SORT_BY.ascend,
  });

  const pagination = {
    current: pageIndex,
    total: affiliationData?.totalSize,
    pageSize: pageSize,
    pageSizeOptions: PAGINATION.pageSizeOptions,
    showSizeChanger: true,
    disabledPageSizehandler: true,
  };

  const { data, isLoading } = useQuery({
    queryKey: [
      QUERY_KEY.SiteAffiliationsTable,
      selectedCustomer?.value,
      pageIndex,
      pageSize,
      sortBy,
      filterExpression,
      hcpFlag,
    ],
    queryFn: async () => {
      const result = await getAffiliationsDataSite(
        selectedCustomer?.value,
        0, // will set actual offset and pageSize once pagination done from backend,
        hcpFlag,
        sortBy.column,
        sortBy.order,
        filterExpression,
        corpParent
      );
      return result?.values?.length > 0 ? result : initailState;
    },
    enabled:
      activeSectionTab === COMPONENT_MAPPING.Affiliations &&
      filterExpression.length > 0
        ? true
        : false,
  });

  // Update local state when query data changes
  useEffect(() => {
    if (data) {
      setAffiliationData(data);
    }
  }, [data]);

  const handleTableChange = (column, order, pagination) => {
    let currentPageSize = pagination.pageSize;

    // Reset page to 1 if page size changed
    if (pageSize !== currentPageSize) {
      setPageIndex(1);
      setPageSize(currentPageSize);
    } else {
      setPageIndex(pagination.current);
    }

    setSortBy({ column, order: SORT_BY[order] });
  };

  const handleFilterApply = (filterExp) => {
    setPageIndex(1);
    setFilterExpression(filterExp);
  };

  const downloadData = () => {
    dispatch(
      exportData(
        'SiteAffiliation',
        selectedCustomer?.value,
        null,
        null,
        null,
        affiliationExpression
      )
    );
  };
  const size = { x: 1300, y: 400 };
  const exportTooltip = (
    <Tooltip className='gne-tooltip'>Send to Excel</Tooltip>
  );

  const resetFilters = () => {
    dispatch(resetAffiliationFilters());
  };

  return (
    <div id='SiteAffiliations'>
      {enableTitle && (
        <Fade>
          <Row className='mt-3'>
            <Col md={6}>
              <p className='title title__bold title__large'> Affiliations </p>
            </Col>
            <Col
              className='d-flex justify-content-end'
              md={6}>
              <OverlayIcon
                tooltip={'Reset Filters'}
                onClick={resetFilters}
                className={`icon icon__reset-filters mt-2 me-3`}
              />
              <OverlayTrigger overlay={exportTooltip}>
                <i
                  onClick={downloadData}
                  className={`icon icon__affiliations_export_excel1 mt-2`}
                />
              </OverlayTrigger>
            </Col>
          </Row>
        </Fade>
      )}
      {!window?.location?.href.includes('customer-hierarchy') ? (
        <Row>
          <AffiliationsFilters
            site={account}
            applyFilter={(filterExp) => handleFilterApply(filterExp)}
          />
        </Row>
      ) : (
        ''
      )}
      <Row>
        <Spin spinning={isLoading || isExporting}>
          <ConfigurableTable
            rows={affiliationData?.values}
            columns={getRestrictedColumn(
              TABLE_NAME_SITE_AFFILIATION,
              columns || SITE_AFFILIATIONS_COLUMNS,
              columnRestriction
            )}
            expandRowByClick={false}
            enableColumnSelection={false}
            enableExport={false}
            exportFileName='affiliations'
            isGlobalExport={true}
            tableName={TABLE_NAME_SITE_AFFILIATION}
            pagination={pagination}
            isGlobalSort={true}
            onSort={handleTableChange}
            tableType={tableType}
            dimentions={size}
          />
        </Spin>
      </Row>
    </div>
  );
};

export default SiteAffiliations;
